import React from "react";
import { Link } from "react-router-dom";
import blue from "./transparent-logo.png";
import "./Header.css";

function Header() {
  return (
    <div className="container">
      <div className="col-auto">
        <Link to="/">
          <img
            id="logo"
            src={blue}
            alt="A company logo"
            title="A company logo"
          />
        </Link>
      </div>
      <div className="row-auto">
        <br />
      </div>
    </div>
  );
}

export default Header;
